export default function ieRequestTimeStamp() {
  if (!navigator) {
    return {};
  }

  const isIE =
    navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;

  if (!isIE) {
    return {};
  }

  return {
    timestamp: Date.now(),
  };
}
